export default "__VITE_ASSET__COnw5Gpq__"